import { observable } from 'mobx'

export const recommendPriceTableData = observable({
  data: []
});
export const priceDetailDrawerState = observable({
  visible: false,
  priceData: null,
  rank: null
});
